import * as React from "react"
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { BuildPartGW } from "./BuildPartGW"
import { BDKalkCore } from "./BDKalkCore"
import { ExtInfoViewGW } from "./ExtInfoViewGW"
import { ChoiseControlQreportGW } from "./ChoiseControlQreportGW"
import { Assert } from "./PADebug" 

///////////////   SelectionViewGW  ////////////////

/* SelectionViewVm renders the quick report view (at the bottom of the page) consisting
 * of a number of rendered SelectionItemGW instances. While the SelectionViewGW class is
 * responsible for the render/update of the quick report view, most of its atcual rendering
 * functionalities are located in SelectionItemGW(the enlisted articles), BDKalkCore and
 * QReportTitleGW (the title bar which expands/collapses the quick report when clicked upon) */
export interface SelectionViewVm  {
    app: App
}

export class SelectionViewGW extends React.Component<SelectionViewVm, {}> {
    constructor(props: SelectionViewVm) {
        super(props)
    }

    componentWillMount() {
        this.props.app.GetCore().ConnectSelectionView(this)
    }

    render() {
        const core = this.props.app.GetCore()
        var buffer = core.GetSelectedArticles()
        var bpBuffer = core.GetSelectedBuildParts()

        var articlesToBedisplayed: Array<ArticleGW> = new Array<ArticleGW>() // This will hold the group of displayed articles, with a set max amount for optimization purposes
        var buildPartsToBedisplayed: Array<BuildPartGW> = new Array<BuildPartGW>() // This will hold the group of displayed buildparts, with a set max amount for optimization purposes

        if ((buffer == null) || (bpBuffer == null)) {
            Assert(false, "SelectionViewGW.render - one of either selected articles or selected buildparts were null - canceled render")
            return <div></div>
        }

        // The following will cause a second render if app states are old and needs to be renewed
        if (this.props.app.state.resultTotalArticles != (buffer.length + bpBuffer.length)) {
            this.props.app.GetCore().SetIncomingResultLength(buffer.length + bpBuffer.length)
            setTimeout(this.props.app.GetCore().UpdateAppStateTotalArticles.bind(this.props.app.GetCore()), 60)
        }

        var startPoint = (this.props.app.state.resultGroup * this.props.app.state.resultGroupLength)

        for (var i = 0, j = startPoint; i < this.props.app.state.resultGroupLength; i++ , j++) {
            if (j < buffer.length) {
                articlesToBedisplayed.push(buffer[j])
            }
            else {
                if ((j - buffer.length) < bpBuffer.length) {
                    buildPartsToBedisplayed.push(bpBuffer[(j - buffer.length)])
                }
                else {
                    break
                }
            }
        }

        var artPart = <div></div>

        if (articlesToBedisplayed.length > 0) {
            artPart = <div>
                {core.RenderQreport(articlesToBedisplayed)}
            </div>
        }

        return <div>
            {artPart}
            {core.GetSelectionSetManager().RenderBuildPartsSelection(buildPartsToBedisplayed)}
            <div style={{ marginLeft: "35px", marginTop:"20px" }}>
                {this.props.app.RenderDisplaySectionGroupControls(true)}
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./client/view/SelectionViewGW.tsx